/* ==========================================================================
   QUILL & CLASP — scripts propios
   Vanilla, sin librerías. Una función init por componente.
   ========================================================================== */

(function () {
  'use strict';

  var prefiereMenosMovimiento =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Reveals al hacer scroll (un solo observer compartido) ------------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.qc-reveal:not(.qc-visible)');
    if (!elementos.length) return;

    if (prefiereMenosMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('qc-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('qc-visible');
          observer.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) { observer.observe(el); });
  }

  /* --- Selector de packs (ficha de producto) ---------------------------- */
  function initPacks() {
    var caja = document.querySelector('[data-qc-packs]');
    if (!caja) return;

    var opciones = caja.querySelectorAll('.qc-packs__radio');
    if (!opciones.length) return;

    function campoCantidad() {
      // OJO: en Dawn el selector de cantidad vive FUERA del <form>;
      // se asocia con el atributo form="...". Por eso se busca en todo el documento.
      return (
        document.querySelector('quantity-input input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]')
      );
    }

    // Evita que pack → cantidad → pack se persigan en bucle
    var enCurso = false;

    function marcarTarjeta(radio) {
      caja.querySelectorAll('.qc-packs__opcion').forEach(function (o) {
        o.classList.remove('qc-packs__opcion--activa');
      });
      if (!radio) return;
      var etiqueta = radio.closest('.qc-packs__opcion');
      if (etiqueta) etiqueta.classList.add('qc-packs__opcion--activa');
    }

    /* Sentido 1: el cliente elige un pack → se fija la cantidad */
    function aplicar(radio) {
      if (enCurso) return;
      enCurso = true;

      marcarTarjeta(radio);

      var campo = campoCantidad();
      if (campo && campo.value !== radio.value) {
        campo.value = radio.value;
        // Dawn escucha 'change' en su componente de cantidad
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      }

      enCurso = false;
    }

    /* Sentido 2: el cliente cambia la cantidad → se marca el pack que toca */
    function desdeCantidad() {
      if (enCurso) return;
      var campo = campoCantidad();
      if (!campo) return;

      enCurso = true;

      var valor = parseInt(campo.value, 10);
      var radio = caja.querySelector('.qc-packs__radio[value="' + valor + '"]');

      if (radio) {
        radio.checked = true;
        marcarTarjeta(radio);
      } else {
        // Cantidad que no corresponde a ningún pack (0, 7, 12…):
        // no se marca ninguno, para no enseñar un precio que no es el suyo.
        opciones.forEach(function (r) { r.checked = false; });
        marcarTarjeta(null);
      }

      enCurso = false;
    }

    opciones.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) aplicar(radio);
      });
    });

    // Escucha el campo de cantidad (teclado y botones +/- de Dawn)
    var campoInicial = campoCantidad();
    if (campoInicial) {
      campoInicial.addEventListener('change', desdeCantidad);
      campoInicial.addEventListener('input', desdeCantidad);
    }

    // Estado inicial: la cantidad del formulario DEBE coincidir con el pack
    // marcado, o el cliente vería "Buy 3" y se le añadiría 1 al carrito.
    // Dawn monta su componente de cantidad más tarde, así que se reintenta.
    function sincronizar() {
      var marcado = caja.querySelector('.qc-packs__radio:checked');
      if (marcado) aplicar(marcado);

      // Reengancha el listener si Dawn ha reemplazado el input
      var campo = campoCantidad();
      if (campo && !campo.dataset.qcEnlazado) {
        campo.dataset.qcEnlazado = '1';
        campo.addEventListener('change', desdeCantidad);
        campo.addEventListener('input', desdeCantidad);
      }
    }

    sincronizar();
    window.addEventListener('load', sincronizar);
    setTimeout(sincronizar, 400);
    setTimeout(sincronizar, 1200);
  }

  /* --- Hoja de revisión del grabado ------------------------------------- */
  function initRevision() {
    var caja = document.querySelector('[data-qc-revision]');
    if (!caja) return;

    var lista = caja.querySelector('[data-qc-revision-lista]');

    function camposGrabado() {
      // Campos de personalización de ShineOn: properties[Front], [Left]…
      return Array.prototype.slice.call(
        document.querySelectorAll(
          'input[name^="properties["], textarea[name^="properties["]'
        )
      ).filter(function (c) {
        // Descarta campos ocultos de la app (tokens, ids internos)
        return c.type !== 'hidden';
      });
    }

    function nombreCara(campo) {
      var m = (campo.name || '').match(/^properties\[(.+)\]$/);
      var bruto = m ? m[1] : campo.name;
      return bruto.replace(/[_-]+/g, ' ').trim();
    }

    function pintar() {
      var campos = camposGrabado();

      if (!campos.length) {
        caja.hidden = true;
        return;
      }
      caja.hidden = false;

      var html = '';
      campos.forEach(function (campo) {
        var valor = (campo.value || '').trim();
        var vacio = valor === '';
        html +=
          '<li class="qc-revision__fila' + (vacio ? ' qc-revision__fila--vacia' : '') + '">' +
          '<span class="qc-revision__cara">' + nombreCara(campo) + '</span>' +
          '<span class="qc-revision__texto">' +
          (vacio ? '<em>Not engraved</em>' : escapar(valor)) +
          '</span>' +
          '</li>';
      });
      lista.innerHTML = html;
    }

    function escapar(t) {
      var d = document.createElement('div');
      d.textContent = t;
      return d.innerHTML;
    }

    // Delegación: sigue funcionando aunque ShineOn recree sus campos
    // al cambiar de variante.
    document.addEventListener('input', function (e) {
      var n = e.target && e.target.name;
      if (n && n.indexOf('properties[') === 0) pintar();
    });
    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name;
      if (n && n.indexOf('properties[') === 0) pintar();
    });

    pintar();
    // La app monta sus campos después: se reintenta.
    window.addEventListener('load', pintar);
    setTimeout(pintar, 600);
    setTimeout(pintar, 1500);
    setTimeout(pintar, 3000);
  }

  /* --- Arranque --------------------------------------------------------- */
  function init() {
    initReveals();
    initPacks();
    initRevision();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sin recargar la página
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Mega menú de "Shop"
   ------------------------------------------------------------
   El panel vive fuera del <li> del menú, así que un :hover de CSS
   lo cerraría en cuanto el ratón bajase del enlace al panel. Se
   controla aquí con un retardo al salir, y se cierra con Escape.
   ============================================================ */
(function () {
  /* Dos paneles, mismo molde: Shop y Collections. Abrir uno cierra el otro. */
  var paneles = [
    { el: document.getElementById('qc-mega'), re: /^\s*shop\s*$/i },
    { el: document.getElementById('qc-mega-col'), re: /^\s*collections\s*$/i }
  ].filter(function (p) { return p.el; });
  if (!paneles.length) return;

  var enlaces = Array.prototype.slice.call(
    document.querySelectorAll('.header__menu-item, .header__inline-menu a')
  );

  paneles.forEach(function (p) {
    var mios = enlaces.filter(function (a) { return p.re.test(a.textContent); });
    if (!mios.length) return;
    var t = null;
    function abrir() {
      clearTimeout(t);
      paneles.forEach(function (q) {
        if (q !== p) q.el.classList.remove('qc-mega--abierto');
      });
      p.el.classList.add('qc-mega--abierto');
    }
    function cerrar() { t = setTimeout(function () { p.el.classList.remove('qc-mega--abierto'); }, 180); }
    mios.forEach(function (a) {
      a.addEventListener('mouseenter', abrir);
      a.addEventListener('mouseleave', cerrar);
      a.addEventListener('focus', abrir);
    });
    p.el.addEventListener('mouseenter', abrir);
    p.el.addEventListener('mouseleave', cerrar);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') paneles.forEach(function (p) { p.el.classList.remove('qc-mega--abierto'); });
  });
})();

/* ============================================================
   Favoritos
   ------------------------------------------------------------
   Persistencia en localStorage. NO se sincroniza con la cuenta de
   Shopify: escribir metacampos de cliente desde el escaparate exige
   la Customer Account API con autenticación de servidor, fuera del
   alcance de un tema. Lo guardado vive en este dispositivo.
   ============================================================ */
(function () {
  var CLAVE = 'qc_favoritos';

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]'); }
    catch (e) { return []; }
  }
  function guardar(l) {
    try { localStorage.setItem(CLAVE, JSON.stringify(l)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('qc:favoritos', { detail: { total: l.length } }));
  }

  function pintar(btn, activo) {
    btn.classList.toggle('qc-fav--activo', activo);
    btn.setAttribute('aria-pressed', activo ? 'true' : 'false');
    btn.setAttribute('title', activo ? 'Saved — tap to remove' : 'Save for later');
  }

  function sincronizar() {
    var l = leer();
    document.querySelectorAll('[data-qc-fav]').forEach(function (b) {
      var k = b.getAttribute('data-qc-handle') || b.getAttribute('data-qc-fav');
      pintar(b, l.indexOf(k) !== -1);
    });
    var c = document.querySelector('[data-qc-fav-contador]');
    if (c) {
      c.textContent = l.length;
      c.hidden = l.length === 0;
      // Con algo guardado el corazón de la cabecera se rellena y el número
      // se lee dentro; vacío, vuelve a ser solo el contorno.
      var caja = document.querySelector('[data-qc-fav-icono]');
      if (caja) caja.classList.toggle('qc-fav-icono--lleno', l.length > 0);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qc-fav]');
    if (!b) return;
    // La tarjeta entera suele ser un enlace; sin esto el clic navega.
    e.preventDefault();
    e.stopPropagation();

    var id = b.getAttribute('data-qc-handle') || b.getAttribute('data-qc-fav');
    var l = leer();
    var i = l.indexOf(id);
    if (i === -1) { l.push(id); } else { l.splice(i, 1); }
    guardar(l);
    sincronizar();

    b.classList.remove('qc-fav--late');
    void b.offsetWidth;               // reinicia la animación
    if (i === -1) b.classList.add('qc-fav--late');
  });

  document.addEventListener('DOMContentLoaded', sincronizar);
  document.addEventListener('qc:favoritos', function () {});
  sincronizar();

  // Expuesto para la página de guardados.
  window.qcFavoritos = { leer: leer, guardar: guardar, sincronizar: sincronizar };
})();


/* ============================================================
   Reja a píxel entero — 16 ago 2026 (v3).
   La reja va en CSS GRID (ver qc-styles.css: así las filas no
   pueden desalinearse entre sí). Aquí solo se fijan columnas de
   píxeles ENTEROS: con 1fr las líneas caen en fracciones y el
   navegador pinta unas nítidas y otras difuminadas. El sobrante
   (0-3px) queda tras la última columna, sobre blanco: invisible.
   ============================================================ */
(function () {
  function ajusta(reja) {
    // limpia restos de la version anterior (anchos fijos por tarjeta)
    [].forEach.call(reja.children, function (h) {
      if (h.style.width) { h.style.width = ''; h.style.maxWidth = ''; h.style.flex = ''; }
    });
    var n = parseInt(getComputedStyle(reja).getPropertyValue('--qc-cols'), 10);
    if (!n) {
      reja.style.gridTemplateColumns = '';
      n = getComputedStyle(reja).gridTemplateColumns.split(' ').length;
    }
    if (!n || n < 2) return;
    var col = Math.floor(reja.clientWidth / n);
    if (col > 40) {
      reja.style.gridTemplateColumns = 'repeat(' + n + ', ' + col + 'px)';
      reja.setAttribute('data-qc-entera', n);
    }
  }
  function todas() {
    document.querySelectorAll('.product-grid, .qc-dest__grid').forEach(ajusta);
  }
  var espera;
  window.addEventListener('resize', function () {
    clearTimeout(espera); espera = setTimeout(todas, 120);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todas);
  } else { todas(); }

  // Dawn reemplaza la reja por AJAX (paginación, filtros): lo aplicado se va
  // con el nodo viejo. El observador ve llegar la reja nueva y lo repone.
  var obs = new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      if (cambios[i].addedNodes.length) {
        document.querySelectorAll('.product-grid:not([data-qc-entera]), .qc-dest__grid:not([data-qc-entera])').forEach(ajusta);
        return;
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();

/* Recuadro destacado de los mega menús, personalizado por navegación.
   La ELECCIÓN no se calcula aquí: la precalcula qc-vista.liquid en cada
   ficha (recomendación de Shopify o lo más mirado) y la deja en
   localStorage `qc_pick`. Aquí solo se PINTA, síncrono y sin red, para
   que el recuadro ya esté cambiado antes de que se abra el menú y no se
   vea el salto desde la pieza fija. Sin historial no se toca nada. */
(function () {
  var promos = document.querySelectorAll('[data-qc-promo]');
  if (!promos.length) return;
  var pick;
  try { pick = JSON.parse(localStorage.getItem('qc_pick') || 'null'); }
  catch (e) { return; }
  if (!pick || !pick.url) return;
  Array.prototype.forEach.call(promos, function (promo) {
    var img = promo.querySelector('[data-qc-promo-img]');
    var et = promo.querySelector('[data-qc-promo-et]');
    var n = promo.querySelector('[data-qc-promo-n]');
    var pr = promo.querySelector('[data-qc-promo-p]');
    if (!img || !n || !pr) return;
    promo.href = pick.url;
    img.src = pick.img;
    img.alt = pick.titulo;
    if (et) et.textContent = pick.etiqueta;
    n.textContent = pick.titulo;
    pr.textContent = (pick.desde ? 'From ' : '') + '$' + (pick.precio / 100).toFixed(2) + ' USD';
  });
})();

/* Protección de paquete de ShineOn — al estilo AppleCare.
   Se elige en la FICHA (dos tarjetas de opción) y aparece en el carrito
   como una línea pequeña colgando de la pieza. Aquí se hacen cuatro cosas:
     1) ficha: al añadir la pieza al carrito, si la clienta eligió proteger,
        se añade también la variante del seguro que corresponda al importe
     2) carrito: se recoloca la línea del seguro justo debajo de la última
        pieza de ShineOn, para que se lea como algo suyo y no suelto
     3) carrito: si el pedido cambia de tramo de precio, se corrige el nivel
     4) carrito: si se quedó el seguro sin ninguna pieza de ShineOn (la
        quitaron), se retira solo: cobrar por asegurar nada sería feo */
(function () {
  var SECCIONES = 'main-cart-items,main-cart-footer,cart-icon-bubble';
  var ocupado = false;

  function pedir(url, cuerpo) {
    cuerpo.sections = SECCIONES;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { pintar(d.sections); return d; });
  }

  function poner(id) { return pedir('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); }
  function quitar(clave) { return pedir('/cart/change.js', { id: clave, quantity: 0 }); }

  /* Mismo criterio que cart.js de Dawn: cada sección se vuelca en su
     .js-contents, salvo el globito del icono del carrito. */
  function pintar(secciones) {
    if (!secciones) return;
    [
      ['main-cart-items', '#main-cart-items'],
      ['main-cart-footer', '#main-cart-footer'],
    ].forEach(function (par) {
      var html = secciones[par[0]];
      var destino = document.querySelector(par[1]);
      if (!html || !destino) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var origen = doc.querySelector('.js-contents');
      var actual = destino.querySelector('.js-contents');
      if (origen && actual) actual.innerHTML = origen.innerHTML;
    });
    var globo = secciones['cart-icon-bubble'];
    var destinoGlobo = document.getElementById('cart-icon-bubble');
    if (globo && destinoGlobo) {
      var d = new DOMParser().parseFromString(globo, 'text/html');
      var src = d.querySelector('.shopify-section');
      if (src) destinoGlobo.innerHTML = src.innerHTML;
    }
    acomodar();
  }

  /* ── 1) Ficha: añadir el seguro junto con la pieza ─────────────────── */
  function engancharFicha() {
    var ficha = document.querySelector('[data-qc-prot-ficha]');
    if (!ficha || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (!evento || evento.source !== 'product-form') return;
      var si = ficha.querySelector('[data-qc-prot-si]');
      if (!si || !si.checked) return;
      var variante = ficha.getAttribute('data-qc-prot-variante');
      /* Si ya hubiera un seguro en el carrito no se duplica: uno por pedido
         basta, y el nivel se corrige después según el importe total. */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          var yaEsta = (carrito.items || []).some(function (i) {
            return /Package Protection/i.test(i.product_title || i.title || '');
          });
          if (!yaEsta) poner(variante);
        })
        .catch(function () {});
    });
  }

  /* ── 2) Carrito: colgar la línea del seguro de la última pieza ─────── */
  function acomodar() {
    var linea = document.querySelector('tr.qc-prot-linea');
    if (!linea) return;
    var piezas = document.querySelectorAll('tr[data-qc-so]');
    if (!piezas.length) return;
    var ultima = piezas[piezas.length - 1];
    if (ultima.nextElementSibling !== linea) {
      ultima.parentNode.insertBefore(linea, ultima.nextElementSibling);
    }
  }

  /* ── 3 y 4) Carrito: corregir el nivel o retirar el seguro huérfano ── */
  function revisar() {
    if (ocupado) return;
    var datos = document.querySelector('[data-qc-prot-datos]');
    if (!datos) return;
    var clave = datos.getAttribute('data-qc-prot-clave');
    var actual = datos.getAttribute('data-qc-prot-actual');
    var correcta = datos.getAttribute('data-qc-prot-correcta');
    if (!clave) return;

    if (datos.getAttribute('data-qc-prot-huerfana') === 'si') {
      ocupado = true;
      quitar(clave).catch(function () {}).then(function () { ocupado = false; });
      return;
    }
    if (!actual || actual === '0' || actual === correcta) return;
    ocupado = true;
    quitar(clave)
      .then(function () { return poner(correcta); })
      .catch(function () {})
      .then(function () { ocupado = false; });
  }

  function arrancar() {
    engancharFicha();
    var pie = document.getElementById('main-cart-footer');
    if (pie) {
      /* Dawn repinta el carrito por su cuenta (cantidades, borrados). Como
         los datos viven dentro de .js-contents, cada repintado los deja
         frescos; se vigila para reaccionar. Cuando ya todo cuadra, revisar()
         sale sin tocar nada, así que no hay bucle. */
      new MutationObserver(function () { acomodar(); revisar(); }).observe(pie, {
        childList: true,
        subtree: true,
      });
    }
    acomodar();
    revisar();
  }

  /* OJO: qc-scripts.js se carga ANTES que pubsub.js en theme.liquid, y los
     dos son `defer`, así que al ejecutarse este archivo `subscribe` todavía
     no existe. Por eso se espera a DOMContentLoaded, que ocurre cuando ya
     corrieron todos los defer. Se protege contra dobles arranques. */
  var arrancado = false;
  function arrancarUnaVez() {
    if (arrancado) return;
    arrancado = true;
    arrancar();
  }
  document.addEventListener('DOMContentLoaded', arrancarUnaVez);
  window.addEventListener('load', arrancarUnaVez);
  if (document.readyState === 'complete') arrancarUnaVez();
})();
